'use strict';

var mcore = require('mcoreapp');
var __mc_T_El = mcore.virtualDom.Element;
var __mc_T_formatters = mcore.Template.formatters;
var __mc_T_binders = mcore.Template.binders;
var __mc_T_components = mcore.Template.components;
var __objectKeys = mcore.util.objectKeys;
var __each = mcore.util.each;
var __isArray = mcore.util.isArray;

module.exports = function(scope, __mc__observe) {
    var __mc__children_0 = [];
    var __mc__binders = {};
    var __mc__dom_id = 0;
    var __pathMap = {};

    var __getPath = function(path) {
        var key = path;
        if (__pathMap[path] >= 0) {
            path = path + ':' + String(__pathMap[path]);
            //console.log(path, String(__pathMap[key]));
            __pathMap[key]++;
            //console.log(path, __pathMap[key]);
        } else {
            __pathMap[path] = 0;
        }
        return path;
    };

    var __parserBinders = function(__mc__binderData, __mc__isBindObserve, key, val) {
        if (__mc_T_binders.hasOwnProperty(key)) {
            __mc__isBindObserve = true;
            __mc__binderData.push({
                attrName: key,
                value: val
            });
        }
        return __mc__isBindObserve;
    };

    var __bindBinder = function(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData) {
        if (!__mc__isBindObserve) {
            var __mc__attr__keys = __objectKeys(__mc__attr);
            __each(__mc__attr__keys, function(attr) {
                if (attr.indexOf('on-') === 0) {
                    __mc__isBindObserve = true;
                }
            });
        }
        if (__mc__isBindObserve || __mc_T_components[__mc__new_el.tagName]) {
            __mc__new_el.bindTemplate(__mc__observe);
        }

        if (__mc__isBindObserve) {
            for (var __mc_i = 0, __mc_len = __mc__binderData.length; __mc_i < __mc_len; __mc_i++) {
                var __mc_v = __mc__binderData[__mc_i];
                __mc__new_el.bindBinder(__mc_v.attrName, __mc_v.value);
            }
        }
    };

    (function(scope, tree) { // startTree 0

        // <h1/>
        var __mc__children_0 = [],
            __mc__attr = {},
            __mc__isBindObserve = false,
            __mc__binderData = [];
        __mc__attr['key'] = __getPath('.0');
        (function(scope, tree) { // startTree 1

            tree.push('hello mcore');
        })(scope, __mc__children_0); // endTree 1
        var __mc__new_el = new __mc_T_El('h1', __mc__attr, __mc__children_0);
        __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
        tree.push(__mc__new_el);
        // <p/>
        var __mc__children_2 = [],
            __mc__attr = {},
            __mc__isBindObserve = false,
            __mc__binderData = [];
        __mc__attr['key'] = __getPath('.2');
        (function(scope, tree) { // startTree 3

            // <a href="javascript:;"  mc-on-click="openV" />
            var __mc__children_3 = [],
                __mc__attr = {},
                __mc__isBindObserve = false,
                __mc__binderData = [];
            __mc__attr['href'] = 'javascript:;';
            __mc__attr['on-click'] = 'openV';
            __mc__attr['key'] = __getPath('.2.1');
            (function(scope, tree) { // startTree 4

                tree.push('Open a PopUpView');
            })(scope, __mc__children_3); // endTree 4
            var __mc__new_el = new __mc_T_El('a', __mc__attr, __mc__children_3);
            __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
            tree.push(__mc__new_el);
        })(scope, __mc__children_2); // endTree 3
        var __mc__new_el = new __mc_T_El('p', __mc__attr, __mc__children_2);
        __bindBinder(__mc__new_el, __mc__attr, __mc__isBindObserve, __mc__binderData);
        tree.push(__mc__new_el);
    })(scope, __mc__children_0); // endTree 0


    if (__mc__children_0.length === 1 && __mc__children_0[0].render) {
        var virtualDom = __mc__children_0[0];
    } else {
        var virtualDom = new __mc_T_El('mc-vd', {}, __mc__children_0);
    }

    var templateDefined = {
        'virtualDom': virtualDom
    };
    return templateDefined;
};


/*****************
 ** WEBPACK FOOTER
 ** ./js/src/tpl/index.html
 ** module id = 4
 ** module chunks = 0
 **/